import request from "../utils/request";


// pc端通过动态码获取项目草稿 /api/Porject/getCodeProjectCg
export function getCodeProjectCg(params) {
    return request({
        url: "/api/face/records/info",
        method: "get",
        params
    });
}